import * as React from "react";
import { colors } from "@aifi-ml/design-system-variables";

interface GoBackIconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const GoBackIcon: React.FC<GoBackIconProps> = ({
  color = colors.light["color/text/general/active"],
  width = 24,
  height = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.25 12H3.75M3.75 12L10.5 5.25M3.75 12L10.5 18.75"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
